import { createContext, useEffect, useState, ReactNode } from "react";
import * as toast from "../utils/alertMessage";
import { AuthControllerService, OpenAPI } from "../services";
import { useApiService } from "../hooks/useApiService";
import { useLogin } from "../hooks/query/useUser";

// Define types for the context values
interface AuthContextType {
  currentUser: any;
  login: (formData: any) => Promise<boolean>;
  // verifyOtpAndLogin: (formData: {
  //   email: string;
  //   otp: string;
  // }) => Promise<void>;
  googleLogin: (token: string) => Promise<void>;
  logout: () => void;
  hasLoggedOut?: boolean;
}

// Default values for AuthContext
const AuthContextDefaultValues: AuthContextType = {
  currentUser: null,
  login: async () => false,
  // verifyOtpAndLogin: async () => {},
  googleLogin: async () => {},
  logout: () => {},
  hasLoggedOut: false,
};

export const AuthContext = createContext<AuthContextType>(
  AuthContextDefaultValues
);

// Define types for the props
interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [currentUser, setCurrentUser] = useState<any>(
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user") as string)
      : null
  );

  const hasLoggedOut = sessionStorage.getItem("hasLoggedOut") === "true";
  // const { mutateAsync: loginMutation, error } = useLogin();
  const { mutateAsync: loginUser } = useLogin();
  const { handleRequest } = useApiService();

  const login = async (formData: any): Promise<boolean> => {
    try {
      const response = await loginUser(formData);
      if (response && response.token) {
        localStorage.setItem("token", response.token);

        OpenAPI.TOKEN = response.token; 

        const profile = await handleRequest(
          AuthControllerService.authControllerGetMyProfile()
        );
        setCurrentUser(profile);
        localStorage.setItem("user", JSON.stringify(profile));
        sessionStorage.removeItem("hasLoggedOut");
        console.log("response", response);
      }
      console.log("User logged in successfully:", response);
      return true;
    } catch (error: any) {
      console.error("Error logging in", error);
      toast.error(error?.body?.error?.message || "Failed to log in.");
      throw new Error(error?.body?.error?.message || "Failed to log in.");
    }
  };

  // const verifyOtpAndLogin = async (formData: {
  //   email: string;
  //   otp: string;
  // }) => {
  //   try {
  //     const res = await verifyOtpMutation(formData);
  //     if (res) {
  //       localStorage.setItem("token", JSON.stringify(res.token));

  //       OpenAPI.TOKEN = res.token;

  //       const profile = await handleRequest(
  //         AuthControllerService.authControllerGetMyProfile()
  //       );
  //       setCurrentUser(profile);
  //       localStorage.setItem("user", JSON.stringify(profile));
  //       console.log("Res", res);
  //     }
  //   } catch (error: any) {
  //     toast.error(error.body?.error?.message || "OTP verification failed");
  //     throw error;
  //   }
  // };

  const googleLogin = async (token: string) => {
    try {
      // Store the token in localStorage
      localStorage.setItem("token", token);
      OpenAPI.TOKEN = token;

      // Fetch user profile after successful login
      const profile = await handleRequest(
        AuthControllerService.authControllerGetMyProfile()
      );

      setCurrentUser(profile);
      localStorage.setItem("user", JSON.stringify(profile));

      console.log("Google Login Successful:", profile);
    } catch (error) {
      toast.error("Google login failed.");
      console.error("Error during Google login:", error);
    }
  };

  const logout = () => {
    setCurrentUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    OpenAPI.TOKEN = undefined;
    sessionStorage.setItem("hasLoggedOut", "true");
  };

  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(currentUser) || "null");

    const params = new URLSearchParams(window.location.search);
    const googleToken = params.get("token");

    if (googleToken) {
      console.log("Google Token FOUND Logging IN ...");
      googleLogin(googleToken);
      window.history.replaceState({}, document.title, "/");
    }
  }, [currentUser]);

  return (
    <AuthContext.Provider
      value={{ currentUser, login, logout, hasLoggedOut, googleLogin }}
    >
      {children}
    </AuthContext.Provider>
  );
};
